// @ts-nocheck
import React, { useState } from 'react';
import './StickyNotesPanel.css';

type NoteType = 'question' | 'idea' | 'important';

interface StickyNote {
  id: string;
  noteType: NoteType;
  content: string;
  page: number;
  selectedText?: string;
}

interface NoteTypeConfig {
  label: string;
  icon: string;
  color: string;
}

interface CreateNoteData {
  noteType: NoteType;
  content: string;
  page: number;
}

interface StickyNotesPanelProps {
  stickyNotes: StickyNote[];
  currentPage: number;
  onCreateNote: (data: CreateNoteData) => void;
  onDeleteNote: (noteId: string) => void;
  onViewNote: (note: StickyNote) => void;
  onUpdateNote?: (noteId: string, updates: Partial<StickyNote>) => void;
  onClose?: () => void;
  [key: string]: any;
}

const StickyNotesPanel: React.FC<StickyNotesPanelProps> = ({
  stickyNotes,
  currentPage,
  onCreateNote,
  onDeleteNote,
  onViewNote,
  onUpdateNote,
  onClose
}) => {
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [noteType, setNoteType] = useState<NoteType>('question');
  const [content, setContent] = useState('');

  const noteTypeConfig: Record<NoteType, NoteTypeConfig> = {
    'question': { label: '疑问', icon: '📝', color: '#FBC02D' },
    'idea': { label: '想法', icon: '💡', color: '#2196F3' },
    'important': { label: '重点', icon: '⚠️', color: '#F44336' }
  };

  const notesByPage: Record<number, StickyNote[]> = {};
  stickyNotes.forEach(note => {
    if (!notesByPage[note.page]) {
      notesByPage[note.page] = [];
    }
    notesByPage[note.page].push(note);
  });

  const handleCreate = () => {
    if (!content.trim()) {
      alert('请输入内容');
      return;
    }

    onCreateNote({
      noteType,
      content: content.trim(),
      page: currentPage
    });

    setContent('');
    setNoteType('question');
    setShowCreateDialog(false);
  };

  return (
    <div className="sticky-notes-panel">
      <div className="sticky-notes-header">
        <h3>📌 便利贴</h3>
        <button
          className="create-note-btn"
          onClick={() => setShowCreateDialog(true)}
          title="创建便利贴"
        >
          + 新建
        </button>
      </div>

      {showCreateDialog && (
        <div className="create-note-dialog">
          <div className="note-type-tabs">
            {(Object.entries(noteTypeConfig) as [NoteType, NoteTypeConfig][]).map(([type, config]) => (
              <button
                key={type}
                className={`type-tab ${noteType === type ? 'active' : ''}`}
                style={{
                  borderColor: noteType === type ? config.color : '#ddd',
                  color: noteType === type ? config.color : '#666'
                }}
                onClick={() => setNoteType(type)}
              >
                {config.icon} {config.label}
              </button>
            ))}
          </div>

          <textarea
            value={content}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setContent(e.target.value)}
            placeholder="输入你的想法、疑问或重点..."
            maxLength={500}
            autoFocus
          />

          <div className="dialog-actions">
            <button onClick={() => {
              setShowCreateDialog(false);
              setContent('');
            }}>
              取消
            </button>
            <button
              onClick={handleCreate}
              disabled={!content.trim()}
              className="save-btn"
            >
              保存
            </button>
          </div>
        </div>
      )}

      <div className="notes-list">
        {Object.keys(notesByPage).length === 0 ? (
          <div className="empty-state">
            <p>暂无便利贴</p>
            <p className="hint">点击"新建"创建第一个便利贴</p>
          </div>
        ) : (
          Object.entries(notesByPage)
            .sort(([pageA], [pageB]) => parseInt(pageA) - parseInt(pageB))
            .map(([page, notes]) => (
              <div key={page} className="page-group">
                <div className="page-header">
                  第 {page} 页
                  <span className="note-count">{notes.length}个</span>
                </div>

                {notes.map(note => {
                  const config = noteTypeConfig[note.noteType];
                  return (
                    <div
                      key={note.id}
                      className="sticky-note-card"
                      style={{ borderLeftColor: config.color }}
                      onClick={() => onViewNote(note)}
                    >
                      <div className="note-header">
                        <span className="note-icon">{config.icon}</span>
                        <span className="note-type">{config.label}</span>
                      </div>
                      <div className="note-content">
                        {note.content}
                      </div>
                      {note.selectedText && (
                        <div className="note-context">
                          <small>关联文本：</small>
                          <div className="context-text">
                            {note.selectedText.substring(0, 50)}
                            {note.selectedText.length > 50 ? '...' : ''}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ))
        )}
      </div>
    </div>
  );
};

export default StickyNotesPanel;
